import './components/questionsAndAnswers';
import './components/more';
import Costs from "./components/costs";

(function () {
    console.log('loveAdoption.js loaded');
    const costsObj = document.getElementById("costs");
    if (costsObj) {
        // Proceed only if the element with id "costs" exists
        new Costs(costsObj);
    }
})();
/*
(function () {
    const buttons = document.querySelectorAll(".loveAdoption__openModal");
    const modal = document.getElementById('pdfModal');

    for (const button of buttons) {
        const pdfUrl = button.dataset.pdfUrl;

        button.addEventListener("click", () => {
            modal.querySelector('#pdfViewer').src = 'https://kmasilice.eu/wp-content/uploads/2025/01/ABUBAKARR-JABBIE.pdf';
            console.log('set');
        })
    }
})();
*/
(function () {
    console.log('loveAdoption.js modal loaded');
    const buttons = document.querySelectorAll(".missionProject__openModal");
    const modal = document.getElementById('donationModal');

    for (const button of buttons) {
        const destination = button.dataset.destination;
        const pdfUrl = button.dataset.title;

        button.addEventListener("click", () => {
            modal.querySelector('#pdfViewer').src = pdfUrl;
            modal.classList.add('active');
        })
    }
})();